<template>
  <div class="wrapper">
    <div class="tilte-text"> 公众号授权 </div>
    <div class="auth-wrap">
      <div class="auth-box">
        <el-row>
          <el-col :span="24">
            <div class="detail-box" v-if="bindPackage.length > 0">
              <div class="detail-div">
                <div class="operate-div" v-for="(item,index) of bindPackage" :key="index">
                  <div>
                    <img v-if="item.headImg" :src="item.headImg" alt="">
                    <img v-else src="../../../../assets/img/official/weishouquan.png" alt="">
                  </div>
                  <div class="wechat-info">
                    <div class="wechat-title" v-if="item.platformName == '' && item.platformUuid == ''">待授权公众号</div>
                    <div class="wechat-title" v-else>{{item.platformName}}</div>
                    <div class="package">{{item.packageName}}</div>
                  </div>
                  <div v-if="item.platformName == '' && item.platformUuid == ''">
                    <!-- <span class="wechat-btn" @click="toAuth()">去授权公众号</span> -->
                    <span class="wechat-btn">
                      <a :href="authLink+item.snapshotId" target="_blank">去授权公众号</a>
                    </span>
                  </div>
                  <div v-else><span class="wechat-btn" @click="lookLink(item)">查看专属推广链接</span></div>
                  <div><span class="wechat-btn" @click="toHome(item)">进入系统</span></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

     <div class="auth-detail">
      <el-row>
        <el-col :span="12" class="left-box">
          <div class="auth-title">授权说明</div>
          <div class="auth-tip">
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content"><span>授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span></div>
            </div>
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content"><span>如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span></div>
            </div>
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content"><span>如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span></div>
            </div>
<!--            <div class="btn-box">-->
<!--              <span class="auth-btn" @click="toAuthorization">添加新公众号</span>-->
<!--            </div>-->
          </div>
        </el-col>
        <el-col :span="12" class="right-box">
          <div class="notice-box">
            <div class="auth-title">注意事项</div>
            <div class="auth-tip">
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>授权成功后，请先同步消息模版</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>不要手动去删除微信公众号生成的消息模板</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>有任何出券码的问题，及时联系客服处理</span></div>
              </div>
            </div>
            <div class="qrcode-box">
              <div class="qrcode-div margin-right-10">
                <img class="qrcode-img" src="../../../../assets/img/official/service1.jpg" alt="">
                <div class="nickname">守兔票务-雪糕</div>
              </div>
              <div class="qrcode-div margin-left-10">
                <img class="qrcode-img" src="../../../../assets/img/official/service2.jpg" alt="">
                <div class="nickname">守兔票务-婷欧尼</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <promotion-link ref="link"></promotion-link>
  </div>
</template>

<script>
  import PromotionLink from '@/components/official/PromotionLink.vue'
  import { getUserUUID, getNickname, getPlatformUuid, getIsBasic, setPlatformUuid, setPlatformName, setIsBasic, setHasPackage, setIsAuthOfficial, getSnaphotId, setSnapshotId, setIsOver, setHeadImg } from '@/utils/auth'
  import official from '@/javaApi/official'
  const officialModel = new official()
  export default {
    name: 'MyWechat',
    components: {
      PromotionLink
    },
    data: function () {
      return {
        listLoading: false,
        platformUuid: getPlatformUuid(),
        userUUID : getUserUUID(),
        bindPackage: [],
        authLink: process.env.VUE_APP_MOVIE_DOMAIN + 'movie/api/dis.distribution/toauth?openUserName=' + getNickname() + '&openUserUuid=' + getUserUUID() + '&snapshotId=',
      }
    },
    created() {
      this.loadPubilc();
    },
    methods: {
      loadPubilc:function(){
        this.listLoading = true
        officialModel.publicLogin({openUserUuid:this.userUUID}).then((response) => {
          let that = this
          var res = response.data
          if(res.code != 200){
            setPlatformUuid(0);
            setPlatformName('')
            setSnapshotId(0)
            setIsOver(1)
            setIsBasic(true)
            setHasPackage(false)
            setIsAuthOfficial(false)
            setHeadImg('')
            that.$Message.error(res.message)
            return
          }
          if(res.data.binds.length > 0){
            let tempSnapshotId = getSnaphotId()
            let defaultOfficial = res.data.binds[0];
            if(tempSnapshotId){
              let targetSnapshotId = tempSnapshotId
              if(targetSnapshotId == -1){
                // targetSnapShotId = -1 表示刚刚添加的公众号 买了套餐
                let lastOfficial = res.data.binds.length
                defaultOfficial =  res.data.binds[lastOfficial-1];
              }else{
                let i;
                let tempData;
                for(i=0;i<res.data.binds.length;i++){
                  tempData = res.data.binds[i]
                  if(targetSnapshotId != 0){
                    if(tempData['snapshotId'] == targetSnapshotId){
                      defaultOfficial = tempData
                      break;
                    }
                  }else{
                    if(tempData['id']>0){
                      defaultOfficial = tempData
                      break;
                    }
                  }
                }
              }
            }
            setPlatformUuid(defaultOfficial.platformUuid);
            setPlatformName(defaultOfficial.platformName)
            if(defaultOfficial.snapshotId !== null){
              setSnapshotId(defaultOfficial.snapshotId)
            }else{
              setSnapshotId(0)
            }
            setIsOver(defaultOfficial.isOver)
            setHeadImg(defaultOfficial.headImg)
            if(defaultOfficial.isProfit === 1){
              setIsBasic(false)
            }else{
              setIsBasic(true)
            }
            if(defaultOfficial.packageName !== null){
              setHasPackage(true)
            }else{
              setHasPackage(false)
            }
            if(defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== ''){
              setIsAuthOfficial(true)
            }else{
              setIsAuthOfficial(false)
            }
          }
          this.bindPackage = res.data.binds
          this.listLoading = false
        }).catch(error=>{
          this.listLoading = false
            if(error != 'token invalid'){
              this.$message.error('系统繁忙请稍后再试!')
            }
        })
      },
      lookLink: function (row) {
        this.$refs.link.init(row)
        console.log('查看专属推广链接')
      },
      //跳转到主页
      toHome(item){
        var platformUuid = item.platformUuid
        var snapshotId = item.snapshotId
        if(item.isProfit === 1){
          setIsBasic(false)
        }else{
          setIsBasic(true)
        }
        setSnapshotId(snapshotId)
        this.$store.dispatch('official/changeIsShowSlide', true)
        this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 0)
        // 快照id
        this.$router.push({
          path: '/pc/official/statistics',
          query: { platformUuid: platformUuid,snapshotId:snapshotId }
        })
      },
      //跳转到公众号授权页面
      toAuth(){
        // this.$store.dispatch('official/changeIsShowSlide', true)
        // this.$router.push({
        //   path: '/pc/official/authorization'
        // })
      },
      toAuthorization(){
        setPlatformUuid(0);
        setPlatformName('')
        setSnapshotId(-1) //表示新添加的公众号
        setIsOver(1)
        setIsBasic(true)
        setHasPackage(false)
        setIsAuthOfficial(false)
        setHeadImg('')
        this.$store.dispatch('official/changeIsShowSlide', true)
        if(getIsBasic() === 'true'){
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex',5)
        }else{
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex',8)
        }
        // this.$router.push({
        //   path: '/pc/official/dialog'
        // }).catch(err => { err })
        // window.open('#/pc/official/dialog?is_new=1','_self')
        // this.$router.go(0)
        this.$router.push({
          path: '/pc/official/dialog',
          query: { is_new: 1 }
        }).catch(err => { err })
      }
    }
  }
</script>

<style scoped>
  .margin-left-10{
    margin-left: 10px;
  }
  .margin-right-10{
    margin-right: 10px;
  }
  .wrapper .tilte-text {
    font-size: 18px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
  .auth-wrap .auth-box{
    padding: 30px 30px 30px 0;
  }
  .auth-wrap .detail-box{
    border: 1px solid #EEEEEE;
    border-radius: 4px;
  }
  .auth-wrap .detail-box .detail-div{
    padding:10px 20px;
  }
  .auth-wrap .detail-box .detail-div .operate-div{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
    color: #FF8622;
    padding: 10px 0;
  }
  .auth-wrap .detail-box .detail-div .operate-div img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .auth-wrap .detail-box .detail-div .operate-div .wechat-info{
    margin: 0 30px 0 15px;
    font-family: Alibaba-PuHuiTi-R;
    width: 130px;
  }
  .auth-wrap .detail-box .detail-div .operate-div .wechat-info .wechat-title{
    font-size: 16px;
    color: #666666;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    -webkit-line-clamp: 1;
  }
  .auth-wrap .detail-box .detail-div .operate-div .wechat-info .package{
    font-size: 13px;
    color: #3D9EFC;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    -webkit-line-clamp: 1;
  }
  .auth-wrap .detail-box .detail-div .operate-div .wechat-btn{
    border: 1px solid #FF8622;
    border-radius: 2px;
    padding: 6px 15px;
    cursor: pointer;
    margin: 0 5px;
    white-space: nowrap;
  }
  .auth-wrap .detail-box .detail-div .operate-div .wechat-btn a{
    color: #FF8622;
  }
  .auth-detail .auth-title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 18px;
    color: #222222;
  }
  .auth-detail .auth-tip{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 13px;
    color: #666666;
    margin-top: 10px;
  }
  .auth-detail .part-box {
    display: flex;
    flex-direction: row;
    padding: 4px 0;
  }
  .auth-detail .part-circle {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: #ff9734;
    margin: 5px 8px 5px 0;
  }
  .auth-detail .right-box .part-circle {
    background: #999999;
  }
  .auth-detail .part-content {
    width: 90%;
  }
  .auth-detail .left-box .btn-box{
    padding: 20px 10px;
  }
  .auth-detail .left-box .btn-box .auth-btn{
    font-family: Alibaba-PuHuiTi-R;
    background: #FF8622;
    border-radius: 2px;
    color: #FFFFFF;
    padding: 6px 15px;
    cursor: pointer;
  }
  .auth-detail .left-box .btn-box .auth-btn a{
    color: #FFFFFF;
  }
  .auth-detail .left-box{
    padding-right:20px;
  }
  .auth-detail .right-box{
    padding-left:20px;
  }
  .auth-detail .right-box .notice-box{
    min-width: 380px;
  }
  .auth-detail .right-box .notice-box .qrcode-box{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-top: 30px;
  }
  .auth-detail .right-box .notice-box .qrcode-box .qrcode-div{
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    width: 180px;
    padding: 20px;
  }
  .auth-detail .right-box .notice-box .qrcode-box .qrcode-div .qrcode-img{
    width: 140px;
    height: 140px;
    object-fit: contain;
  }
  .auth-detail .right-box .notice-box .qrcode-box .qrcode-div .nickname{
    padding-top:10px;
    text-align: center;
    font-size: 14px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/mywechat/Index.vue